import React from 'react';
import Loader from '../../../BaseComponents/Loader';
import TableHeader from '../../../BaseComponents/TableHeader';
import { PmpModality } from '../../../../api/pmpModalities';
import PmpModalitiesTableRow from './PmpModalitiesTableRow';
import './PmpModalitiesTable.scss';

const headerColumns = [
  { title: 'Name', key: 'name', minWidth: '220px', width: '220px', flex: 0 },
  { title: 'Full Price', key: 'full_price', minWidth: '140px', width: '140px', flex: 0 },
  { title: 'Member Price', key: 'member_price', minWidth: '140px', width: '140px', flex: 0 },
  { title: 'Status', key: 'status', minWidth: '120px', width: '120px', flex: 0 },
  { title: '', key: 'actions', minWidth: '48px', width: '48px', flex: 0 },
];

interface PmpModalitiesTableProps {
  modalities: PmpModality[];
  isLoading: boolean;
  onEdit: (modality: PmpModality) => void;
  onToggleStatus: (modality: PmpModality) => void;
}

const PmpModalitiesTable: React.FC<PmpModalitiesTableProps> = ({
  modalities,
  isLoading,
  onEdit,
  onToggleStatus,
}) => {
  if (isLoading) return <Loader />;

  return (
    <div className='scroll-container'>
      <div className='table-container pmp-modalities-table'>
        <TableHeader headerColumns={headerColumns} gap='80px' />
        <div className='table-body'>
          {modalities.length > 0 ? (
            modalities.map((modality) => (
              <PmpModalitiesTableRow
                key={modality.id}
                modality={modality}
                onEdit={onEdit}
                onToggleStatus={onToggleStatus}
              />
            ))
          ) : (
            <div className='no-results-message'>No modalities found.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PmpModalitiesTable;
